import type { ReactNode } from 'react';

export const symbol_file_present: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480.26-220q58.74 0 99.24-41.13Q620-302.25 620-360v-120q0-8.5-6-14.25T600-500q-8 0-14 5.75T580-480v120q0 42-28.75 71T480-260q-42 0-71-29t-29-71v-220q0-18 11.5-29t28.5-11q18 0 29 11t11 29v180q0 8.5 6 14.25t14 5.75q8 0 14-5.75t6-14.25v-180q0-33.6-23.08-56.8-23.07-23.2-56.5-23.2-33.42 0-56.92 23.2T340-580v220q0 57.75 41.2 98.87Q422.41-220 480.26-220ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm0-60h520v-494H584q-12.75 0-21.37-8.63Q554-651.25 554-664v-156H220v680Zm0-680v186-186 680-680Z"
		/>
	</svg>
);
